import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Icon from 'components/Icon';
import CardImage from 'components/CardImage';
import TooltipButton from 'components/TooltipButton';
import getPictureUrl, { PLAYLIST_HERO } from 'utils/image/getPictureUrl';
import { jsx as _jsx } from "react/jsx-runtime";
function PlaylistHeader(_ref) {
  var thumbnailId = _ref.thumbnailId,
    previewUrl = _ref.previewUrl,
    isReady = _ref.isReady,
    backLink = _ref.backLink;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // Reduce the height of the hero image when there's no image
  // - but not when the playlist data hasn't loaded yet.
  // Avoids a jump in header height when the image loads
  var imageHeight = previewUrl || thumbnailId || !isReady ? 230 : 120;
  return /*#__PURE__*/_jsx(CardImage, {
    lazyload: false,
    src: previewUrl || getPictureUrl({
      id: thumbnailId,
      dimensions: PLAYLIST_HERO
    }),
    colorBlock: "playlist",
    aspectRatio: 5 / 12,
    maxHeight: imageHeight,
    fallbackContent: /*#__PURE__*/_jsx(Icon, {
      dimmed: true,
      name: "playlist",
      scale: 1.5
    }),
    children: backLink && /*#__PURE__*/_jsx(Box, {
      position: "absolute",
      top: "s",
      left: "s",
      children: /*#__PURE__*/_jsx(TooltipButton, {
        as: Link,
        to: backLink,
        variant: "shaded",
        icon: "arrow",
        title: t('actions_back')
      })
    })
  });
}
export default PlaylistHeader;